import { render, staticRenderFns } from "./DateValue.vue?vue&type=template&id=2b768c02&"
import script from "./DateValue.vue?vue&type=script&lang=js&"
export * from "./DateValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports